import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadObjListStatus: 'idle',
    loadObjListError: undefined as any,
    loadObjListLastArgs: undefined as any,
    loadObjStatus: 'idle',
    loadObjError: undefined as any,
    saveObjStatus: 'idle',
    saveObjError: undefined as any,
    deleteObjStatus: 'idle',
    deleteObjError: undefined as any,
    loadBukreisListStatus: 'idle',
    loadBukreisListError: undefined as any,
    loadBukreisListLastArgs: undefined as any,
    loadBuKreisByIdStatus: 'idle',
    loadBuKreisByIdError: undefined as any,
    saveBukreisStatus: 'idle',
    saveBukreisError: undefined as any,
    deleteBukreisStatus: 'idle',
    deleteBukreisError: undefined as any,
    loadBuKreisByObjNrStatus: 'idle',
    loadBuKreisByObjNrError: undefined as any,
    loadBuKreisFibuStatus: 'idle',
    loadBuKreisFibuError: undefined as any,
    loadGrpStatus: 'idle',
    loadGrpError: undefined as any,
    loadObjzusatzListStatus: 'idle',
    loadObjzusatzListError: undefined as any,
    loadObjzusatzListLastArgs: undefined as any,
    loadObjzusatzStatus: 'idle',
    loadObjzusatzError: undefined as any,
    loadObjZusatzFibuStatus: 'idle',
    loadObjZusatzFibuError: undefined as any,
    loadObjzusatzByIdStatus: 'idle',
    loadObjzusatzByIdError: undefined as any,
    saveObjzusatzStatus: 'idle',
    saveObjzusatzError: undefined as any,
    saveObjzusatzFibuStatus: 'idle',
    saveObjzusatzFibuError: undefined as any,
    deleteObjzusatzStatus: 'idle',
    deleteObjzusatzError: undefined as any,
    loadObjCompanyStatus: 'idle',
    loadObjCompanyError: undefined as any,
    loadLzkDEStatus: 'idle',
    loadLzkDEError: undefined as any,
    StammIni_AnmietungStatus: 'idle',
    StammIni_AnmietungError: undefined as any,
    BuchIni_UstVAVtOpBtKreisBeruecksichtigenStatus: 'idle',
    BuchIni_UstVAVtOpBtKreisBeruecksichtigenError: undefined as any,
    BuchIni_UstVA15Status: 'idle',
    BuchIni_UstVA15Error: undefined as any,
    BuchIni_BuServerDCLInterimAufUObjIniStatus: 'idle',
    BuchIni_BuServerDCLInterimAufUObjIniError: undefined as any,
    FlaecheIni_UnterMietFlAktiviereUnterflaechenStatus: 'idle',
    FlaecheIni_UnterMietFlAktiviereUnterflaechenError: undefined as any,
    BuchIni_DialogbuchhaltungWeiterleitungDisabelnStatus: 'idle',
    BuchIni_DialogbuchhaltungWeiterleitungDisabelnError: undefined as any,
    BuchIni_IntercompanyStatus: 'idle',
    BuchIni_IntercompanyError: undefined as any,
    BuchIni_CashPoolingStatus: 'idle',
    BuchIni_CashPoolingError: undefined as any,
    BuchIni_MahnwesenKeinVorschlagBeiVerwaltungsendeStatus: 'idle',
    BuchIni_MahnwesenKeinVorschlagBeiVerwaltungsendeError: undefined as any,
    BuchIni_BuServerVerbFordKtoKreDebAufUObjIniStatus: 'idle',
    BuchIni_BuServerVerbFordKtoKreDebAufUObjIniError: undefined as any,
    loadObjMainItemStatus: 'idle',
    loadObjMainItemError: undefined as any,
    saveObjMainItemStatus: 'idle',
    saveObjMainItemError: undefined as any,
    loadObjParameterItemStatus: 'idle',
    loadObjParameterItemError: undefined as any,
    saveObjParameterItemStatus: 'idle',
    saveObjParameterItemError: undefined as any,
    loadObjParameter2ItemStatus: 'idle',
    loadObjParameter2ItemError: undefined as any,
    saveObjParameter2ItemStatus: 'idle',
    saveObjParameter2ItemError: undefined as any,

    objList: [] as any[],
    buchIni_BuServerDCLInterimAufUObjIni: undefined as any,
    buchIni_BuServerVerbFordKtoKreDebAufUObjIni: undefined as any,
    buchIni_CashPooling: undefined as any,
    buchIni_DialogbuchhaltungWeiterleitungDisabeln: undefined as any,
    buchIni_Intercompany: undefined as any,
    buchIni_MahnwesenKeinVorschlagBeiVerwaltungsende: undefined as any,
    buchIni_UstVA15: undefined as any,
    buchIni_UstVAVtOpBtKreisBeruecksichtigen: undefined as any,
    bukreis: undefined as any,
    bukreisList: [] as any,
    currentBukreis: undefined as any,
    currentBukreisFibu: undefined as any,
    currentGrp: undefined as any,
    currentLkzDE: undefined as any,
    currentObjzusatz: undefined as any,
    currentObjzusatzFibu: undefined as any,
    currentOwnObjComany: undefined as any,
    flaecheIni_UnterMietFlAktiviereUnterflaechen: undefined as any,
    formItem: undefined as any,
    objzusatzList: [] as any,
    parameter2FormItem: undefined as any,
    parameterFormItem: undefined as any,
    stammIni_Anmeitung: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadObjList = createAsyncThunk('objSlice/loadObjList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().objSlice.loadObjListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/obj/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadObjListStatus } = getState().objSlice
        return loadObjListStatus !== 'pending'
    }
})

export const loadObj = createAsyncThunk('objSlice/loadObj', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/obj/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadObjStatus } = getState().objSlice
        return loadObjStatus !== 'pending'
    }
})

export const saveObj = createAsyncThunk('objSlice/saveObj', async ({ obj }: any, { rejectWithValue }: any) => {
    let promises = []
    if (obj?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/obj/${ obj?.HDR_ID }/`,
            prepareData(obj),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/obj/`,
            prepareData(obj),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveObjStatus } = getState().objSlice
        return saveObjStatus !== 'pending'
    }
})

export const deleteObj = createAsyncThunk('objSlice/deleteObj', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/obj/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteObjStatus } = getState().objSlice
        return deleteObjStatus !== 'pending'
    }
})

export const loadBukreisList = createAsyncThunk('objSlice/loadBukreisList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().objSlice.loadBukreisListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/bukreis/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadBukreisListStatus } = getState().objSlice
        return loadBukreisListStatus !== 'pending'
    }
})

export const loadBuKreisById = createAsyncThunk('objSlice/loadBuKreisById', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/bukreis/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadBuKreisByIdStatus } = getState().objSlice
        return loadBuKreisByIdStatus !== 'pending'
    }
})

export const saveBukreis = createAsyncThunk('objSlice/saveBukreis', async ({ bukreis }: any, { rejectWithValue }: any) => {
    let promises = []
    if (bukreis?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/bukreis/${ bukreis?.HDR_ID }/`,
            prepareData(bukreis),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/bukreis/`,
            prepareData(bukreis),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveBukreisStatus } = getState().objSlice
        return saveBukreisStatus !== 'pending'
    }
})

export const deleteBukreis = createAsyncThunk('objSlice/deleteBukreis', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/bukreis/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteBukreisStatus } = getState().objSlice
        return deleteBukreisStatus !== 'pending'
    }
})

export const loadBuKreisByObjNr = createAsyncThunk('objSlice/loadBuKreisByObjNr', async ({ obj }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/bukreis/?action=eql&OBJNR=${obj.OBJNR}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadBuKreisByObjNrStatus } = getState().objSlice
        return loadBuKreisByObjNrStatus !== 'pending'
    }
})

export const loadBuKreisFibu = createAsyncThunk('objSlice/loadBuKreisFibu', async ({ grp }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/bukreis/?action=eql&OBJNR=${grp.OBJNRFIBU}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadBuKreisFibuStatus } = getState().objSlice
        return loadBuKreisFibuStatus !== 'pending'
    }
})

export const loadGrp = createAsyncThunk('objSlice/loadGrp', async ({ obj }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/gruppendb/?action=eql&ID=${obj.O_GROUP}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadGrpStatus } = getState().objSlice
        return loadGrpStatus !== 'pending'
    }
})

export const loadObjzusatzList = createAsyncThunk('objSlice/loadObjzusatzList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().objSlice.loadObjzusatzListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/objzusatz/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadObjzusatzListStatus } = getState().objSlice
        return loadObjzusatzListStatus !== 'pending'
    }
})

export const loadObjzusatz = createAsyncThunk('objSlice/loadObjzusatz', async ({ obj }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/objzusatz/?action=eql&OBJNR=${obj.OBJNR}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadObjzusatzStatus } = getState().objSlice
        return loadObjzusatzStatus !== 'pending'
    }
})

export const loadObjZusatzFibu = createAsyncThunk('objSlice/loadObjZusatzFibu', async ({ grp }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/objzusatz/?action=eql&OBJNR=${grp.OBJNRFIBU}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadObjZusatzFibuStatus } = getState().objSlice
        return loadObjZusatzFibuStatus !== 'pending'
    }
})

export const loadObjzusatzById = createAsyncThunk('objSlice/loadObjzusatzById', async ({ objZusatz }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/objzusatz/?action=eql&HDR_ID=${objZusatz.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadObjzusatzByIdStatus } = getState().objSlice
        return loadObjzusatzByIdStatus !== 'pending'
    }
})

export const saveObjzusatz = createAsyncThunk('objSlice/saveObjzusatz', async ({ objZusatz }: any, { rejectWithValue }: any) => {
    let promises = []
    if (objZusatz?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/objzusatz/${ objZusatz?.HDR_ID }/`,
            prepareData(objZusatz),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/objzusatz/`,
            prepareData(objZusatz),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveObjzusatzStatus } = getState().objSlice
        return saveObjzusatzStatus !== 'pending'
    }
})

export const saveObjzusatzFibu = createAsyncThunk('objSlice/saveObjzusatzFibu', async ({ objZusatzFibu }: any, { rejectWithValue }: any) => {
    let promises = []
    if (objZusatzFibu?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/objzusatz/${ objZusatzFibu?.HDR_ID }/`,
            prepareData(objZusatzFibu),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/objzusatz/`,
            prepareData(objZusatzFibu),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveObjzusatzFibuStatus } = getState().objSlice
        return saveObjzusatzFibuStatus !== 'pending'
    }
})

export const deleteObjzusatz = createAsyncThunk('objSlice/deleteObjzusatz', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/objzusatz/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteObjzusatzStatus } = getState().objSlice
        return deleteObjzusatzStatus !== 'pending'
    }
})

export const loadObjCompany = createAsyncThunk('objSlice/loadObjCompany', async ({ objZusatzFibu }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/own/?action=eql&NO=${objZusatzFibu.EIGENTUEMERNR}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadObjCompanyStatus } = getState().objSlice
        return loadObjCompanyStatus !== 'pending'
    }
})

export const loadLzkDE = createAsyncThunk('objSlice/loadLzkDE', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/lkz/?action=eql&LKZ=DE`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadLzkDEStatus } = getState().objSlice
        return loadLzkDEStatus !== 'pending'
    }
})

export const StammIni_Anmietung = createAsyncThunk('objSlice/StammIni_Anmietung', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/StammIni_Anmietung/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { StammIni_AnmietungStatus } = getState().objSlice
        return StammIni_AnmietungStatus !== 'pending'
    }
})

export const BuchIni_UstVAVtOpBtKreisBeruecksichtigen = createAsyncThunk('objSlice/BuchIni_UstVAVtOpBtKreisBeruecksichtigen', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/BuchIni_UstVAVtOpBtKreisBeruecksichtigen/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { BuchIni_UstVAVtOpBtKreisBeruecksichtigenStatus } = getState().objSlice
        return BuchIni_UstVAVtOpBtKreisBeruecksichtigenStatus !== 'pending'
    }
})

export const BuchIni_UstVA15 = createAsyncThunk('objSlice/BuchIni_UstVA15', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/BuchIni_UstVA15/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { BuchIni_UstVA15Status } = getState().objSlice
        return BuchIni_UstVA15Status !== 'pending'
    }
})

export const BuchIni_BuServerDCLInterimAufUObjIni = createAsyncThunk('objSlice/BuchIni_BuServerDCLInterimAufUObjIni', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/BuchIni_BuServerDCLInterimAufUObjIni/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { BuchIni_BuServerDCLInterimAufUObjIniStatus } = getState().objSlice
        return BuchIni_BuServerDCLInterimAufUObjIniStatus !== 'pending'
    }
})

export const FlaecheIni_UnterMietFlAktiviereUnterflaechen = createAsyncThunk('objSlice/FlaecheIni_UnterMietFlAktiviereUnterflaechen', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/FlaecheIni_UnterMietFlAktiviereUnterflaechen/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { FlaecheIni_UnterMietFlAktiviereUnterflaechenStatus } = getState().objSlice
        return FlaecheIni_UnterMietFlAktiviereUnterflaechenStatus !== 'pending'
    }
})

export const BuchIni_DialogbuchhaltungWeiterleitungDisabeln = createAsyncThunk('objSlice/BuchIni_DialogbuchhaltungWeiterleitungDisabeln', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/BuchIni_DialogbuchhaltungWeiterleitungDisabeln/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { BuchIni_DialogbuchhaltungWeiterleitungDisabelnStatus } = getState().objSlice
        return BuchIni_DialogbuchhaltungWeiterleitungDisabelnStatus !== 'pending'
    }
})

export const BuchIni_Intercompany = createAsyncThunk('objSlice/BuchIni_Intercompany', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/BuchIni_Intercompany/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { BuchIni_IntercompanyStatus } = getState().objSlice
        return BuchIni_IntercompanyStatus !== 'pending'
    }
})

export const BuchIni_CashPooling = createAsyncThunk('objSlice/BuchIni_CashPooling', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/BuchIni_CashPooling/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { BuchIni_CashPoolingStatus } = getState().objSlice
        return BuchIni_CashPoolingStatus !== 'pending'
    }
})

export const BuchIni_MahnwesenKeinVorschlagBeiVerwaltungsende = createAsyncThunk('objSlice/BuchIni_MahnwesenKeinVorschlagBeiVerwaltungsende', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/BuchIni_MahnwesenKeinVorschlagBeiVerwaltungsende/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { BuchIni_MahnwesenKeinVorschlagBeiVerwaltungsendeStatus } = getState().objSlice
        return BuchIni_MahnwesenKeinVorschlagBeiVerwaltungsendeStatus !== 'pending'
    }
})

export const BuchIni_BuServerVerbFordKtoKreDebAufUObjIni = createAsyncThunk('objSlice/BuchIni_BuServerVerbFordKtoKreDebAufUObjIni', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/BuchIni_BuServerVerbFordKtoKreDebAufUObjIni/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { BuchIni_BuServerVerbFordKtoKreDebAufUObjIniStatus } = getState().objSlice
        return BuchIni_BuServerVerbFordKtoKreDebAufUObjIniStatus !== 'pending'
    }
})

export const loadObjMainItem = createAsyncThunk('objSlice/loadObjMainItem', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/obj/?action=eql&HDR_ID=${id}`,
    ))

    const [objRes] = await Promise.all(promises)
    const obj = getRespData(objRes, rejectWithValue, true)
    promises = []
    promises.push(client.get(
        `/api/ixweb/gruppendb/?action=eql&ID=${obj.O_GROUP}`,
    ))

    const [grpRes] = await Promise.all(promises)
    const grp = getRespData(grpRes, null, true)
    promises = []
    promises.push(client.get(
        `/api/ixweb/bukreis/?action=eql&OBJNR=${grp.OBJNRFIBU}`,
    ))

    const [bukreisRes] = await Promise.all(promises)
    const bukreis = getRespData(bukreisRes, null, true)

    return {
        data: {
            ...obj,
            grp: { ...grp },
            bukreis: { ...bukreis },
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadObjMainItemStatus } = getState().objSlice
        return loadObjMainItemStatus !== 'pending'
    }
})

export const saveObjMainItem = createAsyncThunk('objSlice/saveObjMainItem', async ({ obj }: any, { rejectWithValue }: any) => {
    let promises = []
    if (obj?.id) {
        promises.push(client.put(
            `/api/ixweb/obj/${ obj?.id }/`,
            prepareData(obj),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/obj/`,
            prepareData(obj),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveObjMainItemStatus } = getState().objSlice
        return saveObjMainItemStatus !== 'pending'
    }
})

export const loadObjParameterItem = createAsyncThunk('objSlice/loadObjParameterItem', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/obj/?action=eql&HDR_ID=${id}`,
    ))

    const [objRes] = await Promise.all(promises)
    const obj = getRespData(objRes, rejectWithValue, true)
    promises = []
    promises.push(client.get(
        `/api/ixweb/gruppendb/?action=eql&ID=${obj.O_GROUP}`,
    ))
    promises.push(client.get(
        `/api/ixweb/objzusatz/?action=eql&OBJNR=${obj.OBJNR}`,
    ))

    const [grpRes, objZusatzRes] = await Promise.all(promises)
    const grp = getRespData(grpRes, null, true)
    const objZusatz = getRespData(objZusatzRes, null, true)
    promises = []
    promises.push(client.get(
        `/api/ixweb/objzusatz/?action=eql&OBJNR=${grp.OBJNRFIBU}`,
    ))

    const [objZusatzFibuRes] = await Promise.all(promises)
    const objZusatzFibu = getRespData(objZusatzFibuRes, null, true)

    return {
        data: {
            ...obj,
            grp: { ...grp },
            objZusatz: { ...objZusatz },
            objZusatzFibu: { ...objZusatzFibu },
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadObjParameterItemStatus } = getState().objSlice
        return loadObjParameterItemStatus !== 'pending'
    }
})

export const saveObjParameterItem = createAsyncThunk('objSlice/saveObjParameterItem', async ({ obj }: any, { rejectWithValue }: any) => {
    let promises = []
    if (obj?.id) {
        promises.push(client.put(
            `/api/ixweb/obj/${ obj?.id }/`,
            prepareData(obj),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/obj/`,
            prepareData(obj),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveObjParameterItemStatus } = getState().objSlice
        return saveObjParameterItemStatus !== 'pending'
    }
})

export const loadObjParameter2Item = createAsyncThunk('objSlice/loadObjParameter2Item', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/obj/?action=eql&HDR_ID=${id}`,
    ))
    promises.push(client.get(
        `/api/ixweb/lkz/?action=eql&LKZ=DE`,
    ))

    const [objRes, lkzDERes] = await Promise.all(promises)
    const obj = getRespData(objRes, rejectWithValue, true)
    const lkzDE = getRespData(lkzDERes, rejectWithValue, true)
    promises = []
    promises.push(client.get(
        `/api/ixweb/gruppendb/?action=eql&ID=${obj.O_GROUP}`,
    ))
    promises.push(client.get(
        `/api/ixweb/objzusatz/?action=eql&OBJNR=${obj.OBJNR}`,
    ))

    const [grpRes, objZusatzRes] = await Promise.all(promises)
    const grp = getRespData(grpRes, null, true)
    const objZusatz = getRespData(objZusatzRes, null, true)
    promises = []
    promises.push(client.get(
        `/api/ixweb/objzusatz/?action=eql&OBJNR=${grp.OBJNRFIBU}`,
    ))

    const [objZusatzFibuRes] = await Promise.all(promises)
    const objZusatzFibu = getRespData(objZusatzFibuRes, null, true)
    promises = []
    promises.push(client.get(
        `/api/ixweb/own/?action=eql&NO=${objZusatzFibu.EIGENTUEMERNR}`,
    ))

    const [objCompanyRes] = await Promise.all(promises)
    const objCompany = getRespData(objCompanyRes, null, true)

    return {
        data: {
            ...obj,
            grp: { ...grp },
            objZusatz: { ...objZusatz },
            objZusatzFibu: { ...objZusatzFibu },
            objCompany: { ...objCompany },
            lkzDE: { ...lkzDE },
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadObjParameter2ItemStatus } = getState().objSlice
        return loadObjParameter2ItemStatus !== 'pending'
    }
})

export const saveObjParameter2Item = createAsyncThunk('objSlice/saveObjParameter2Item', async ({ obj }: any, { rejectWithValue }: any) => {
    let promises = []
    if (obj?.id) {
        promises.push(client.put(
            `/api/ixweb/obj/${ obj?.id }/`,
            prepareData(obj),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/obj/`,
            prepareData(obj),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveObjParameter2ItemStatus } = getState().objSlice
        return saveObjParameter2ItemStatus !== 'pending'
    }
})

const ObjSlice = createSlice({
    name: 'objSlice',
    initialState,
    reducers: {
        resetloadObjListError: (state) => {
            state.loadObjListError = undefined
        },
        resetloadObj: (state) => {
            state.formItem = undefined
            state.loadObjError = undefined
        },
        resetloadObjError: (state) => {
            state.loadObjError = undefined
        },
        resetsaveObj: (state) => {
            state.formItem = undefined
            state.saveObjError = undefined
        },
        resetsaveObjError: (state) => {
            state.saveObjError = undefined
        },
        resetdeleteObjError: (state) => {
            state.deleteObjError = undefined
        },
        resetloadBukreisList: (state) => {
            state.bukreisList = undefined
            state.loadBukreisListError = undefined
        },
        resetloadBukreisListError: (state) => {
            state.loadBukreisListError = undefined
        },
        resetloadBuKreisById: (state) => {
            state.bukreis = undefined
            state.loadBuKreisByIdError = undefined
        },
        resetloadBuKreisByIdError: (state) => {
            state.loadBuKreisByIdError = undefined
        },
        resetsaveBukreis: (state) => {
            state.bukreis = undefined
            state.saveBukreisError = undefined
        },
        resetsaveBukreisError: (state) => {
            state.saveBukreisError = undefined
        },
        resetdeleteBukreisError: (state) => {
            state.deleteBukreisError = undefined
        },
        resetloadBuKreisByObjNr: (state) => {
            state.currentBukreis = undefined
            state.loadBuKreisByObjNrError = undefined
        },
        resetloadBuKreisByObjNrError: (state) => {
            state.loadBuKreisByObjNrError = undefined
        },
        resetloadBuKreisFibu: (state) => {
            state.currentBukreisFibu = undefined
            state.loadBuKreisFibuError = undefined
        },
        resetloadBuKreisFibuError: (state) => {
            state.loadBuKreisFibuError = undefined
        },
        resetloadGrp: (state) => {
            state.currentGrp = undefined
            state.loadGrpError = undefined
        },
        resetloadGrpError: (state) => {
            state.loadGrpError = undefined
        },
        resetloadObjzusatzList: (state) => {
            state.objzusatzList = undefined
            state.loadObjzusatzListError = undefined
        },
        resetloadObjzusatzListError: (state) => {
            state.loadObjzusatzListError = undefined
        },
        resetloadObjzusatz: (state) => {
            state.currentObjzusatz = undefined
            state.loadObjzusatzError = undefined
        },
        resetloadObjzusatzError: (state) => {
            state.loadObjzusatzError = undefined
        },
        resetloadObjZusatzFibu: (state) => {
            state.currentObjzusatzFibu = undefined
            state.loadObjZusatzFibuError = undefined
        },
        resetloadObjZusatzFibuError: (state) => {
            state.loadObjZusatzFibuError = undefined
        },
        resetloadObjzusatzById: (state) => {
            state.currentObjzusatz = undefined
            state.loadObjzusatzByIdError = undefined
        },
        resetloadObjzusatzByIdError: (state) => {
            state.loadObjzusatzByIdError = undefined
        },
        resetsaveObjzusatz: (state) => {
            state.currentObjzusatz = undefined
            state.saveObjzusatzError = undefined
        },
        resetsaveObjzusatzError: (state) => {
            state.saveObjzusatzError = undefined
        },
        resetsaveObjzusatzFibu: (state) => {
            state.currentObjzusatzFibu = undefined
            state.saveObjzusatzFibuError = undefined
        },
        resetsaveObjzusatzFibuError: (state) => {
            state.saveObjzusatzFibuError = undefined
        },
        resetdeleteObjzusatzError: (state) => {
            state.deleteObjzusatzError = undefined
        },
        resetloadObjCompany: (state) => {
            state.currentOwnObjComany = undefined
            state.loadObjCompanyError = undefined
        },
        resetloadObjCompanyError: (state) => {
            state.loadObjCompanyError = undefined
        },
        resetloadLzkDE: (state) => {
            state.currentLkzDE = undefined
            state.loadLzkDEError = undefined
        },
        resetloadLzkDEError: (state) => {
            state.loadLzkDEError = undefined
        },
        resetStammIni_Anmietung: (state) => {
            state.stammIni_Anmeitung = undefined
            state.StammIni_AnmietungError = undefined
        },
        resetStammIni_AnmietungError: (state) => {
            state.StammIni_AnmietungError = undefined
        },
        resetBuchIni_UstVAVtOpBtKreisBeruecksichtigen: (state) => {
            state.buchIni_UstVAVtOpBtKreisBeruecksichtigen = undefined
            state.BuchIni_UstVAVtOpBtKreisBeruecksichtigenError = undefined
        },
        resetBuchIni_UstVAVtOpBtKreisBeruecksichtigenError: (state) => {
            state.BuchIni_UstVAVtOpBtKreisBeruecksichtigenError = undefined
        },
        resetBuchIni_UstVA15: (state) => {
            state.buchIni_UstVA15 = undefined
            state.BuchIni_UstVA15Error = undefined
        },
        resetBuchIni_UstVA15Error: (state) => {
            state.BuchIni_UstVA15Error = undefined
        },
        resetBuchIni_BuServerDCLInterimAufUObjIni: (state) => {
            state.buchIni_BuServerDCLInterimAufUObjIni = undefined
            state.BuchIni_BuServerDCLInterimAufUObjIniError = undefined
        },
        resetBuchIni_BuServerDCLInterimAufUObjIniError: (state) => {
            state.BuchIni_BuServerDCLInterimAufUObjIniError = undefined
        },
        resetFlaecheIni_UnterMietFlAktiviereUnterflaechen: (state) => {
            state.flaecheIni_UnterMietFlAktiviereUnterflaechen = undefined
            state.FlaecheIni_UnterMietFlAktiviereUnterflaechenError = undefined
        },
        resetFlaecheIni_UnterMietFlAktiviereUnterflaechenError: (state) => {
            state.FlaecheIni_UnterMietFlAktiviereUnterflaechenError = undefined
        },
        resetBuchIni_DialogbuchhaltungWeiterleitungDisabeln: (state) => {
            state.buchIni_DialogbuchhaltungWeiterleitungDisabeln = undefined
            state.BuchIni_DialogbuchhaltungWeiterleitungDisabelnError = undefined
        },
        resetBuchIni_DialogbuchhaltungWeiterleitungDisabelnError: (state) => {
            state.BuchIni_DialogbuchhaltungWeiterleitungDisabelnError = undefined
        },
        resetBuchIni_Intercompany: (state) => {
            state.buchIni_Intercompany = undefined
            state.BuchIni_IntercompanyError = undefined
        },
        resetBuchIni_IntercompanyError: (state) => {
            state.BuchIni_IntercompanyError = undefined
        },
        resetBuchIni_CashPooling: (state) => {
            state.buchIni_CashPooling = undefined
            state.BuchIni_CashPoolingError = undefined
        },
        resetBuchIni_CashPoolingError: (state) => {
            state.BuchIni_CashPoolingError = undefined
        },
        resetBuchIni_MahnwesenKeinVorschlagBeiVerwaltungsende: (state) => {
            state.buchIni_MahnwesenKeinVorschlagBeiVerwaltungsende = undefined
            state.BuchIni_MahnwesenKeinVorschlagBeiVerwaltungsendeError = undefined
        },
        resetBuchIni_MahnwesenKeinVorschlagBeiVerwaltungsendeError: (state) => {
            state.BuchIni_MahnwesenKeinVorschlagBeiVerwaltungsendeError = undefined
        },
        resetBuchIni_BuServerVerbFordKtoKreDebAufUObjIni: (state) => {
            state.buchIni_BuServerVerbFordKtoKreDebAufUObjIni = undefined
            state.BuchIni_BuServerVerbFordKtoKreDebAufUObjIniError = undefined
        },
        resetBuchIni_BuServerVerbFordKtoKreDebAufUObjIniError: (state) => {
            state.BuchIni_BuServerVerbFordKtoKreDebAufUObjIniError = undefined
        },
        resetloadObjMainItem: (state) => {
            state.formItem = undefined
            state.loadObjMainItemError = undefined
        },
        resetloadObjMainItemError: (state) => {
            state.loadObjMainItemError = undefined
        },
        resetsaveObjMainItem: (state) => {
            state.formItem = undefined
            state.saveObjMainItemError = undefined
        },
        resetsaveObjMainItemError: (state) => {
            state.saveObjMainItemError = undefined
        },
        resetloadObjParameterItem: (state) => {
            state.parameterFormItem = undefined
            state.loadObjParameterItemError = undefined
        },
        resetloadObjParameterItemError: (state) => {
            state.loadObjParameterItemError = undefined
        },
        resetsaveObjParameterItem: (state) => {
            state.parameterFormItem = undefined
            state.saveObjParameterItemError = undefined
        },
        resetsaveObjParameterItemError: (state) => {
            state.saveObjParameterItemError = undefined
        },
        resetloadObjParameter2Item: (state) => {
            state.parameter2FormItem = undefined
            state.loadObjParameter2ItemError = undefined
        },
        resetloadObjParameter2ItemError: (state) => {
            state.loadObjParameter2ItemError = undefined
        },
        resetsaveObjParameter2Item: (state) => {
            state.parameter2FormItem = undefined
            state.saveObjParameter2ItemError = undefined
        },
        resetsaveObjParameter2ItemError: (state) => {
            state.saveObjParameter2ItemError = undefined
        },
        removeFromObjListById: (state, action) => {
            state.objList = state.objList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromObjListByIds: (state, action) => {
            state.objList = state.objList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        removeFromBukreisListById: (state, action) => {
            state.bukreisList = state.bukreisList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromBukreisListByIds: (state, action) => {
            state.bukreisList = state.bukreisList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        removeFromObjzusatzListById: (state, action) => {
            state.objzusatzList = state.objzusatzList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromObjzusatzListByIds: (state, action) => {
            state.objzusatzList = state.objzusatzList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.objList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadObjListStatus = 'preloaded'
            state.loadObjListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.objList = []
            state.loadObjListStatus = 'idle'
            state.loadObjListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadObjList.pending, (state) => {
            state.loadObjListStatus = 'pending'
            state.loadObjListError = undefined
        })
        builder.addCase(loadObjList.fulfilled, (state, action) => {
            state.loadObjListStatus = 'idle'

            if (!action.payload) { return }

            state.loadObjListLastArgs = action.payload.args

            {
                state.objList = action.payload.data

            }
        })
        builder.addCase(loadObjList.rejected, (state, action) => {
            state.loadObjListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadObjListError = action.error.message
            } else {
                state.loadObjListError = action.payload
            }
        })

        builder.addCase(loadObj.pending, (state) => {
            state.loadObjStatus = 'pending'
            state.loadObjError = undefined
        })
        builder.addCase(loadObj.fulfilled, (state, action) => {
            state.loadObjStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.objList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.objList.push(newItem) }
                else { state.objList[i] = { ...state.objList[i], ...newItem } }
            }
        })
        builder.addCase(loadObj.rejected, (state, action) => {
            state.loadObjStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadObjError = action.error.message
            } else {
                state.loadObjError = action.payload
            }
        })

        builder.addCase(saveObj.pending, (state) => {
            state.saveObjStatus = 'pending'
            state.saveObjError = undefined
        })
        builder.addCase(saveObj.fulfilled, (state, action) => {
            state.saveObjStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.objList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.objList.push(newItem) }
                else { state.objList[i] = { ...state.objList[i], ...newItem } }
            }
        })
        builder.addCase(saveObj.rejected, (state, action) => {
            state.saveObjStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveObjError = action.error.message
            } else {
                state.saveObjError = action.payload
            }
        })

        builder.addCase(deleteObj.pending, (state) => {
            state.deleteObjStatus = 'pending'
            state.deleteObjError = undefined
        })
        builder.addCase(deleteObj.fulfilled, (state, action) => {
            state.deleteObjStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.objList = state.objList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.objList = state.objList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteObj.rejected, (state, action) => {
            state.deleteObjStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteObjError = action.error.message
            } else {
                state.deleteObjError = action.payload
            }
        })

        builder.addCase(loadBukreisList.pending, (state) => {
            state.loadBukreisListStatus = 'pending'
            state.loadBukreisListError = undefined
        })
        builder.addCase(loadBukreisList.fulfilled, (state, action) => {
            state.loadBukreisListStatus = 'idle'

            if (!action.payload) { return }

            state.loadBukreisListLastArgs = action.payload.args

            {
                state.bukreisList = action.payload.data

            }
        })
        builder.addCase(loadBukreisList.rejected, (state, action) => {
            state.loadBukreisListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadBukreisListError = action.error.message
            } else {
                state.loadBukreisListError = action.payload
            }
        })

        builder.addCase(loadBuKreisById.pending, (state) => {
            state.loadBuKreisByIdStatus = 'pending'
            state.loadBuKreisByIdError = undefined
        })
        builder.addCase(loadBuKreisById.fulfilled, (state, action) => {
            state.loadBuKreisByIdStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.bukreis = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.objList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.objList.push(newItem) }
                else { state.objList[i] = { ...state.objList[i], ...newItem } }
            }
        })
        builder.addCase(loadBuKreisById.rejected, (state, action) => {
            state.loadBuKreisByIdStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadBuKreisByIdError = action.error.message
            } else {
                state.loadBuKreisByIdError = action.payload
            }
        })

        builder.addCase(saveBukreis.pending, (state) => {
            state.saveBukreisStatus = 'pending'
            state.saveBukreisError = undefined
        })
        builder.addCase(saveBukreis.fulfilled, (state, action) => {
            state.saveBukreisStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.bukreis = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.objList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.objList.push(newItem) }
                else { state.objList[i] = { ...state.objList[i], ...newItem } }
            }
        })
        builder.addCase(saveBukreis.rejected, (state, action) => {
            state.saveBukreisStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveBukreisError = action.error.message
            } else {
                state.saveBukreisError = action.payload
            }
        })

        builder.addCase(deleteBukreis.pending, (state) => {
            state.deleteBukreisStatus = 'pending'
            state.deleteBukreisError = undefined
        })
        builder.addCase(deleteBukreis.fulfilled, (state, action) => {
            state.deleteBukreisStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.objList = state.objList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.objList = state.objList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteBukreis.rejected, (state, action) => {
            state.deleteBukreisStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteBukreisError = action.error.message
            } else {
                state.deleteBukreisError = action.payload
            }
        })

        builder.addCase(loadBuKreisByObjNr.pending, (state) => {
            state.loadBuKreisByObjNrStatus = 'pending'
            state.loadBuKreisByObjNrError = undefined
        })
        builder.addCase(loadBuKreisByObjNr.fulfilled, (state, action) => {
            state.loadBuKreisByObjNrStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.currentBukreis = newItem
            }
        })
        builder.addCase(loadBuKreisByObjNr.rejected, (state, action) => {
            state.loadBuKreisByObjNrStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadBuKreisByObjNrError = action.error.message
            } else {
                state.loadBuKreisByObjNrError = action.payload
            }
        })

        builder.addCase(loadBuKreisFibu.pending, (state) => {
            state.loadBuKreisFibuStatus = 'pending'
            state.loadBuKreisFibuError = undefined
        })
        builder.addCase(loadBuKreisFibu.fulfilled, (state, action) => {
            state.loadBuKreisFibuStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.currentBukreisFibu = newItem
            }
        })
        builder.addCase(loadBuKreisFibu.rejected, (state, action) => {
            state.loadBuKreisFibuStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadBuKreisFibuError = action.error.message
            } else {
                state.loadBuKreisFibuError = action.payload
            }
        })

        builder.addCase(loadGrp.pending, (state) => {
            state.loadGrpStatus = 'pending'
            state.loadGrpError = undefined
        })
        builder.addCase(loadGrp.fulfilled, (state, action) => {
            state.loadGrpStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.currentGrp = newItem
            }
        })
        builder.addCase(loadGrp.rejected, (state, action) => {
            state.loadGrpStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadGrpError = action.error.message
            } else {
                state.loadGrpError = action.payload
            }
        })

        builder.addCase(loadObjzusatzList.pending, (state) => {
            state.loadObjzusatzListStatus = 'pending'
            state.loadObjzusatzListError = undefined
        })
        builder.addCase(loadObjzusatzList.fulfilled, (state, action) => {
            state.loadObjzusatzListStatus = 'idle'

            if (!action.payload) { return }

            state.loadObjzusatzListLastArgs = action.payload.args

            {
                state.objzusatzList = action.payload.data

            }
        })
        builder.addCase(loadObjzusatzList.rejected, (state, action) => {
            state.loadObjzusatzListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadObjzusatzListError = action.error.message
            } else {
                state.loadObjzusatzListError = action.payload
            }
        })

        builder.addCase(loadObjzusatz.pending, (state) => {
            state.loadObjzusatzStatus = 'pending'
            state.loadObjzusatzError = undefined
        })
        builder.addCase(loadObjzusatz.fulfilled, (state, action) => {
            state.loadObjzusatzStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.currentObjzusatz = newItem
            }
        })
        builder.addCase(loadObjzusatz.rejected, (state, action) => {
            state.loadObjzusatzStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadObjzusatzError = action.error.message
            } else {
                state.loadObjzusatzError = action.payload
            }
        })

        builder.addCase(loadObjZusatzFibu.pending, (state) => {
            state.loadObjZusatzFibuStatus = 'pending'
            state.loadObjZusatzFibuError = undefined
        })
        builder.addCase(loadObjZusatzFibu.fulfilled, (state, action) => {
            state.loadObjZusatzFibuStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.currentObjzusatzFibu = newItem
            }
        })
        builder.addCase(loadObjZusatzFibu.rejected, (state, action) => {
            state.loadObjZusatzFibuStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadObjZusatzFibuError = action.error.message
            } else {
                state.loadObjZusatzFibuError = action.payload
            }
        })

        builder.addCase(loadObjzusatzById.pending, (state) => {
            state.loadObjzusatzByIdStatus = 'pending'
            state.loadObjzusatzByIdError = undefined
        })
        builder.addCase(loadObjzusatzById.fulfilled, (state, action) => {
            state.loadObjzusatzByIdStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.currentObjzusatz = newItem
            }
        })
        builder.addCase(loadObjzusatzById.rejected, (state, action) => {
            state.loadObjzusatzByIdStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadObjzusatzByIdError = action.error.message
            } else {
                state.loadObjzusatzByIdError = action.payload
            }
        })

        builder.addCase(saveObjzusatz.pending, (state) => {
            state.saveObjzusatzStatus = 'pending'
            state.saveObjzusatzError = undefined
        })
        builder.addCase(saveObjzusatz.fulfilled, (state, action) => {
            state.saveObjzusatzStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.currentObjzusatz = newItem
            }
        })
        builder.addCase(saveObjzusatz.rejected, (state, action) => {
            state.saveObjzusatzStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveObjzusatzError = action.error.message
            } else {
                state.saveObjzusatzError = action.payload
            }
        })

        builder.addCase(saveObjzusatzFibu.pending, (state) => {
            state.saveObjzusatzFibuStatus = 'pending'
            state.saveObjzusatzFibuError = undefined
        })
        builder.addCase(saveObjzusatzFibu.fulfilled, (state, action) => {
            state.saveObjzusatzFibuStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.currentObjzusatzFibu = newItem
            }
        })
        builder.addCase(saveObjzusatzFibu.rejected, (state, action) => {
            state.saveObjzusatzFibuStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveObjzusatzFibuError = action.error.message
            } else {
                state.saveObjzusatzFibuError = action.payload
            }
        })

        builder.addCase(deleteObjzusatz.pending, (state) => {
            state.deleteObjzusatzStatus = 'pending'
            state.deleteObjzusatzError = undefined
        })
        builder.addCase(deleteObjzusatz.fulfilled, (state, action) => {
            state.deleteObjzusatzStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.objList = state.objList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.objList = state.objList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteObjzusatz.rejected, (state, action) => {
            state.deleteObjzusatzStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteObjzusatzError = action.error.message
            } else {
                state.deleteObjzusatzError = action.payload
            }
        })

        builder.addCase(loadObjCompany.pending, (state) => {
            state.loadObjCompanyStatus = 'pending'
            state.loadObjCompanyError = undefined
        })
        builder.addCase(loadObjCompany.fulfilled, (state, action) => {
            state.loadObjCompanyStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.currentOwnObjComany = newItem
            }
        })
        builder.addCase(loadObjCompany.rejected, (state, action) => {
            state.loadObjCompanyStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadObjCompanyError = action.error.message
            } else {
                state.loadObjCompanyError = action.payload
            }
        })

        builder.addCase(loadLzkDE.pending, (state) => {
            state.loadLzkDEStatus = 'pending'
            state.loadLzkDEError = undefined
        })
        builder.addCase(loadLzkDE.fulfilled, (state, action) => {
            state.loadLzkDEStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.currentLkzDE = newItem
            }
        })
        builder.addCase(loadLzkDE.rejected, (state, action) => {
            state.loadLzkDEStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadLzkDEError = action.error.message
            } else {
                state.loadLzkDEError = action.payload
            }
        })

        builder.addCase(StammIni_Anmietung.pending, (state) => {
            state.StammIni_AnmietungStatus = 'pending'
            state.StammIni_AnmietungError = undefined
        })
        builder.addCase(StammIni_Anmietung.fulfilled, (state, action) => {
            state.StammIni_AnmietungStatus = 'idle'

            {
                state.stammIni_Anmeitung = action.payload

            }
        })
        builder.addCase(StammIni_Anmietung.rejected, (state, action) => {
            state.StammIni_AnmietungStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.StammIni_AnmietungError = action.error.message
            } else {
                state.StammIni_AnmietungError = action.payload
            }
        })

        builder.addCase(BuchIni_UstVAVtOpBtKreisBeruecksichtigen.pending, (state) => {
            state.BuchIni_UstVAVtOpBtKreisBeruecksichtigenStatus = 'pending'
            state.BuchIni_UstVAVtOpBtKreisBeruecksichtigenError = undefined
        })
        builder.addCase(BuchIni_UstVAVtOpBtKreisBeruecksichtigen.fulfilled, (state, action) => {
            state.BuchIni_UstVAVtOpBtKreisBeruecksichtigenStatus = 'idle'

            {
                state.buchIni_UstVAVtOpBtKreisBeruecksichtigen = action.payload

            }
        })
        builder.addCase(BuchIni_UstVAVtOpBtKreisBeruecksichtigen.rejected, (state, action) => {
            state.BuchIni_UstVAVtOpBtKreisBeruecksichtigenStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.BuchIni_UstVAVtOpBtKreisBeruecksichtigenError = action.error.message
            } else {
                state.BuchIni_UstVAVtOpBtKreisBeruecksichtigenError = action.payload
            }
        })

        builder.addCase(BuchIni_UstVA15.pending, (state) => {
            state.BuchIni_UstVA15Status = 'pending'
            state.BuchIni_UstVA15Error = undefined
        })
        builder.addCase(BuchIni_UstVA15.fulfilled, (state, action) => {
            state.BuchIni_UstVA15Status = 'idle'

            {
                state.buchIni_UstVA15 = action.payload

            }
        })
        builder.addCase(BuchIni_UstVA15.rejected, (state, action) => {
            state.BuchIni_UstVA15Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.BuchIni_UstVA15Error = action.error.message
            } else {
                state.BuchIni_UstVA15Error = action.payload
            }
        })

        builder.addCase(BuchIni_BuServerDCLInterimAufUObjIni.pending, (state) => {
            state.BuchIni_BuServerDCLInterimAufUObjIniStatus = 'pending'
            state.BuchIni_BuServerDCLInterimAufUObjIniError = undefined
        })
        builder.addCase(BuchIni_BuServerDCLInterimAufUObjIni.fulfilled, (state, action) => {
            state.BuchIni_BuServerDCLInterimAufUObjIniStatus = 'idle'

            {
                state.buchIni_BuServerDCLInterimAufUObjIni = action.payload

            }
        })
        builder.addCase(BuchIni_BuServerDCLInterimAufUObjIni.rejected, (state, action) => {
            state.BuchIni_BuServerDCLInterimAufUObjIniStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.BuchIni_BuServerDCLInterimAufUObjIniError = action.error.message
            } else {
                state.BuchIni_BuServerDCLInterimAufUObjIniError = action.payload
            }
        })

        builder.addCase(FlaecheIni_UnterMietFlAktiviereUnterflaechen.pending, (state) => {
            state.FlaecheIni_UnterMietFlAktiviereUnterflaechenStatus = 'pending'
            state.FlaecheIni_UnterMietFlAktiviereUnterflaechenError = undefined
        })
        builder.addCase(FlaecheIni_UnterMietFlAktiviereUnterflaechen.fulfilled, (state, action) => {
            state.FlaecheIni_UnterMietFlAktiviereUnterflaechenStatus = 'idle'

            {
                state.flaecheIni_UnterMietFlAktiviereUnterflaechen = action.payload

            }
        })
        builder.addCase(FlaecheIni_UnterMietFlAktiviereUnterflaechen.rejected, (state, action) => {
            state.FlaecheIni_UnterMietFlAktiviereUnterflaechenStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.FlaecheIni_UnterMietFlAktiviereUnterflaechenError = action.error.message
            } else {
                state.FlaecheIni_UnterMietFlAktiviereUnterflaechenError = action.payload
            }
        })

        builder.addCase(BuchIni_DialogbuchhaltungWeiterleitungDisabeln.pending, (state) => {
            state.BuchIni_DialogbuchhaltungWeiterleitungDisabelnStatus = 'pending'
            state.BuchIni_DialogbuchhaltungWeiterleitungDisabelnError = undefined
        })
        builder.addCase(BuchIni_DialogbuchhaltungWeiterleitungDisabeln.fulfilled, (state, action) => {
            state.BuchIni_DialogbuchhaltungWeiterleitungDisabelnStatus = 'idle'

            {
                state.buchIni_DialogbuchhaltungWeiterleitungDisabeln = action.payload

            }
        })
        builder.addCase(BuchIni_DialogbuchhaltungWeiterleitungDisabeln.rejected, (state, action) => {
            state.BuchIni_DialogbuchhaltungWeiterleitungDisabelnStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.BuchIni_DialogbuchhaltungWeiterleitungDisabelnError = action.error.message
            } else {
                state.BuchIni_DialogbuchhaltungWeiterleitungDisabelnError = action.payload
            }
        })

        builder.addCase(BuchIni_Intercompany.pending, (state) => {
            state.BuchIni_IntercompanyStatus = 'pending'
            state.BuchIni_IntercompanyError = undefined
        })
        builder.addCase(BuchIni_Intercompany.fulfilled, (state, action) => {
            state.BuchIni_IntercompanyStatus = 'idle'

            {
                state.buchIni_Intercompany = action.payload

            }
        })
        builder.addCase(BuchIni_Intercompany.rejected, (state, action) => {
            state.BuchIni_IntercompanyStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.BuchIni_IntercompanyError = action.error.message
            } else {
                state.BuchIni_IntercompanyError = action.payload
            }
        })

        builder.addCase(BuchIni_CashPooling.pending, (state) => {
            state.BuchIni_CashPoolingStatus = 'pending'
            state.BuchIni_CashPoolingError = undefined
        })
        builder.addCase(BuchIni_CashPooling.fulfilled, (state, action) => {
            state.BuchIni_CashPoolingStatus = 'idle'

            {
                state.buchIni_CashPooling = action.payload

            }
        })
        builder.addCase(BuchIni_CashPooling.rejected, (state, action) => {
            state.BuchIni_CashPoolingStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.BuchIni_CashPoolingError = action.error.message
            } else {
                state.BuchIni_CashPoolingError = action.payload
            }
        })

        builder.addCase(BuchIni_MahnwesenKeinVorschlagBeiVerwaltungsende.pending, (state) => {
            state.BuchIni_MahnwesenKeinVorschlagBeiVerwaltungsendeStatus = 'pending'
            state.BuchIni_MahnwesenKeinVorschlagBeiVerwaltungsendeError = undefined
        })
        builder.addCase(BuchIni_MahnwesenKeinVorschlagBeiVerwaltungsende.fulfilled, (state, action) => {
            state.BuchIni_MahnwesenKeinVorschlagBeiVerwaltungsendeStatus = 'idle'

            {
                state.buchIni_MahnwesenKeinVorschlagBeiVerwaltungsende = action.payload

            }
        })
        builder.addCase(BuchIni_MahnwesenKeinVorschlagBeiVerwaltungsende.rejected, (state, action) => {
            state.BuchIni_MahnwesenKeinVorschlagBeiVerwaltungsendeStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.BuchIni_MahnwesenKeinVorschlagBeiVerwaltungsendeError = action.error.message
            } else {
                state.BuchIni_MahnwesenKeinVorschlagBeiVerwaltungsendeError = action.payload
            }
        })

        builder.addCase(BuchIni_BuServerVerbFordKtoKreDebAufUObjIni.pending, (state) => {
            state.BuchIni_BuServerVerbFordKtoKreDebAufUObjIniStatus = 'pending'
            state.BuchIni_BuServerVerbFordKtoKreDebAufUObjIniError = undefined
        })
        builder.addCase(BuchIni_BuServerVerbFordKtoKreDebAufUObjIni.fulfilled, (state, action) => {
            state.BuchIni_BuServerVerbFordKtoKreDebAufUObjIniStatus = 'idle'

            {
                state.buchIni_BuServerVerbFordKtoKreDebAufUObjIni = action.payload

            }
        })
        builder.addCase(BuchIni_BuServerVerbFordKtoKreDebAufUObjIni.rejected, (state, action) => {
            state.BuchIni_BuServerVerbFordKtoKreDebAufUObjIniStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.BuchIni_BuServerVerbFordKtoKreDebAufUObjIniError = action.error.message
            } else {
                state.BuchIni_BuServerVerbFordKtoKreDebAufUObjIniError = action.payload
            }
        })

        builder.addCase(loadObjMainItem.pending, (state) => {
            state.loadObjMainItemStatus = 'pending'
            state.loadObjMainItemError = undefined
        })
        builder.addCase(loadObjMainItem.fulfilled, (state, action) => {
            state.loadObjMainItemStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
        })
        builder.addCase(loadObjMainItem.rejected, (state, action) => {
            state.loadObjMainItemStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadObjMainItemError = action.error.message
            } else {
                state.loadObjMainItemError = action.payload
            }
        })

        builder.addCase(saveObjMainItem.pending, (state) => {
            state.saveObjMainItemStatus = 'pending'
            state.saveObjMainItemError = undefined
        })
        builder.addCase(saveObjMainItem.fulfilled, (state, action) => {
            state.saveObjMainItemStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
        })
        builder.addCase(saveObjMainItem.rejected, (state, action) => {
            state.saveObjMainItemStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveObjMainItemError = action.error.message
            } else {
                state.saveObjMainItemError = action.payload
            }
        })

        builder.addCase(loadObjParameterItem.pending, (state) => {
            state.loadObjParameterItemStatus = 'pending'
            state.loadObjParameterItemError = undefined
        })
        builder.addCase(loadObjParameterItem.fulfilled, (state, action) => {
            state.loadObjParameterItemStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.parameterFormItem = newItem
            }
        })
        builder.addCase(loadObjParameterItem.rejected, (state, action) => {
            state.loadObjParameterItemStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadObjParameterItemError = action.error.message
            } else {
                state.loadObjParameterItemError = action.payload
            }
        })

        builder.addCase(saveObjParameterItem.pending, (state) => {
            state.saveObjParameterItemStatus = 'pending'
            state.saveObjParameterItemError = undefined
        })
        builder.addCase(saveObjParameterItem.fulfilled, (state, action) => {
            state.saveObjParameterItemStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.parameterFormItem = newItem
            }
        })
        builder.addCase(saveObjParameterItem.rejected, (state, action) => {
            state.saveObjParameterItemStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveObjParameterItemError = action.error.message
            } else {
                state.saveObjParameterItemError = action.payload
            }
        })

        builder.addCase(loadObjParameter2Item.pending, (state) => {
            state.loadObjParameter2ItemStatus = 'pending'
            state.loadObjParameter2ItemError = undefined
        })
        builder.addCase(loadObjParameter2Item.fulfilled, (state, action) => {
            state.loadObjParameter2ItemStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.parameter2FormItem = newItem
            }
        })
        builder.addCase(loadObjParameter2Item.rejected, (state, action) => {
            state.loadObjParameter2ItemStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadObjParameter2ItemError = action.error.message
            } else {
                state.loadObjParameter2ItemError = action.payload
            }
        })

        builder.addCase(saveObjParameter2Item.pending, (state) => {
            state.saveObjParameter2ItemStatus = 'pending'
            state.saveObjParameter2ItemError = undefined
        })
        builder.addCase(saveObjParameter2Item.fulfilled, (state, action) => {
            state.saveObjParameter2ItemStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.parameter2FormItem = newItem
            }
        })
        builder.addCase(saveObjParameter2Item.rejected, (state, action) => {
            state.saveObjParameter2ItemStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveObjParameter2ItemError = action.error.message
            } else {
                state.saveObjParameter2ItemError = action.payload
            }
        })

    }
})

export const {
    resetloadObjListError,
    resetloadObj,
    resetloadObjError,
    resetsaveObj,
    resetsaveObjError,
    resetdeleteObjError,
    resetloadBukreisList,
    resetloadBukreisListError,
    resetloadBuKreisById,
    resetloadBuKreisByIdError,
    resetsaveBukreis,
    resetsaveBukreisError,
    resetdeleteBukreisError,
    resetloadBuKreisByObjNr,
    resetloadBuKreisByObjNrError,
    resetloadBuKreisFibu,
    resetloadBuKreisFibuError,
    resetloadGrp,
    resetloadGrpError,
    resetloadObjzusatzList,
    resetloadObjzusatzListError,
    resetloadObjzusatz,
    resetloadObjzusatzError,
    resetloadObjZusatzFibu,
    resetloadObjZusatzFibuError,
    resetloadObjzusatzById,
    resetloadObjzusatzByIdError,
    resetsaveObjzusatz,
    resetsaveObjzusatzError,
    resetsaveObjzusatzFibu,
    resetsaveObjzusatzFibuError,
    resetdeleteObjzusatzError,
    resetloadObjCompany,
    resetloadObjCompanyError,
    resetloadLzkDE,
    resetloadLzkDEError,
    resetStammIni_Anmietung,
    resetStammIni_AnmietungError,
    resetBuchIni_UstVAVtOpBtKreisBeruecksichtigen,
    resetBuchIni_UstVAVtOpBtKreisBeruecksichtigenError,
    resetBuchIni_UstVA15,
    resetBuchIni_UstVA15Error,
    resetBuchIni_BuServerDCLInterimAufUObjIni,
    resetBuchIni_BuServerDCLInterimAufUObjIniError,
    resetFlaecheIni_UnterMietFlAktiviereUnterflaechen,
    resetFlaecheIni_UnterMietFlAktiviereUnterflaechenError,
    resetBuchIni_DialogbuchhaltungWeiterleitungDisabeln,
    resetBuchIni_DialogbuchhaltungWeiterleitungDisabelnError,
    resetBuchIni_Intercompany,
    resetBuchIni_IntercompanyError,
    resetBuchIni_CashPooling,
    resetBuchIni_CashPoolingError,
    resetBuchIni_MahnwesenKeinVorschlagBeiVerwaltungsende,
    resetBuchIni_MahnwesenKeinVorschlagBeiVerwaltungsendeError,
    resetBuchIni_BuServerVerbFordKtoKreDebAufUObjIni,
    resetBuchIni_BuServerVerbFordKtoKreDebAufUObjIniError,
    resetloadObjMainItem,
    resetloadObjMainItemError,
    resetsaveObjMainItem,
    resetsaveObjMainItemError,
    resetloadObjParameterItem,
    resetloadObjParameterItemError,
    resetsaveObjParameterItem,
    resetsaveObjParameterItemError,
    resetloadObjParameter2Item,
    resetloadObjParameter2ItemError,
    resetsaveObjParameter2Item,
    resetsaveObjParameter2ItemError,
    removeFromObjListById,
    removeFromObjListByIds,
    removeFromBukreisListById,
    removeFromBukreisListByIds,
    removeFromObjzusatzListById,
    removeFromObjzusatzListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ObjSlice.actions
export default ObjSlice.reducer
